import React from "react"
import { Button } from "antd"
import ModalComponent from "../../../shared/components/Modals/ModalComponent"
import ModalBody from "../../../shared/components/Modals/ModalBody"
import warning from "../../../shared/assets/images/warning.svg"
import { EndInterviewModalProps } from "./types"



export const EndInterviewModal: React.FC<EndInterviewModalProps> = ({ visible, onClose, onConfirm }) => {
    return (
        <ModalComponent
            className="my-4"
            isLoadingModal={false}
            visibleModal={visible}
            handleCloseModal={onClose}
            content={
                <ModalBody
                    icon={warning}
                    title={'End Interview?'}
                >
                    <div>
                        <div className="mb-6 text-sm font-normal text-gray-500">
                            <p>Ending the interview now will stop your recording and close the session.<br /> Are you sure you want to proceed?</p>
                        </div>
                        <div className='grid gap-3 md:grid-cols-2'>
                            <Button
                                className='btn-md btn-danger'
                                onClick={onConfirm}>
                                End
                            </Button>
                            <Button
                                className='btn-md'
                                htmlType='submit'
                                onClick={onClose}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            }
        />
    )
}

